import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[NumericNumber]'
})

export class NumericNumberDirective {

  private regex: RegExp = new RegExp(/^\d+$/);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete', 'Control', 'Ctrl'];
  private lastKey: any;
  constructor(private el: ElementRef) {
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: any) {
    if ((this.lastKey === 'Control' || this.lastKey === 'Ctrl') && (event.key === 'a' || event.key === 'A')) {
      event.target.select();
    }
    if (this.specialKeys.indexOf(event.key) !== -1) {
      this.lastKey = event.key;
      return;
    }
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex) && event.keyCode !== 86) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(e: ClipboardEvent) {
    const event = e.clipboardData.getData('text/plain');
    // allow paste only number values
    if (!Number(event)) {
      e.preventDefault();
    } else {
      this.el.nativeElement.value = event;
    }
  }
}
